<template>
    <b-table
        id="comarcas"
        :items="resultado"
        :fields="fields"
        striped
        small
        responsive="sm"
        :no-local-sorting="true"
        @sort-changed="sortingChanged"
        :busy="configTable.load"
        show-empty
        > 
        <div slot="table-busy" class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong> Carregando...</strong>
        </div>
        <template slot="empty">
            <p class="my-auto">Nenhuma comarca encontrada.</p>
        </template>
        <template slot="HEAD_selecionar">
            <b-form-checkbox v-model="configTable.checkedAll" class="justify-content-center text-center" @change="toggleAll" />
        </template>
        <template slot="selecionar" slot-scope="row">
            <b-form-checkbox class="mx-auto justify-content-center text-center" :checked="selecteds.includes(row.item.codComarca)" @change="toggleCheck($event, row.item)" />
        </template>
        <template slot="1" slot-scope="row">
            <p class="m-0 p-0"> {{ row.item.nome }} </p>
        </template>
        <template slot="2" slot-scope="row">
            <p class="m-0 p-0"> {{ row.item.sigla }} </p>
        </template>
        <template slot="3" slot-scope="row">
            <p class="m-0 p-0"> {{ row.item.municipio }} </p>
        </template>
        <template slot="4" slot-scope="row">
            <p class="m-0 p-0"> {{ row.item.limiteTitulosDiarios }} </p>
        </template>
    </b-table>
</template>

<script>
export default {
    props: ['resultado', 'fields', 'configTable', 'selecteds'],
    watch: {
        currentPage() {
            this.configTable.checkedAll = false
            this.$emit('consultar')
        }
    },
    computed: {
        currentPage() {
            return this.configTable.currentPage
        },
    },
    methods: {
        toggleAll(checked) {
            if(checked) {
                this.resultado.forEach(el => {
                    el.checked = true;
                    if(!this.selecteds.includes(el.codComarca)) {
                        this.selecteds.push(el.codComarca)
                    }
                })
            } else {
                this.resultado.forEach(el => {
                    el.checked = false;
                    if(this.selecteds.includes(el.codComarca)) {
                        const index = this.selecteds.indexOf(el.codComarca)
                        this.selecteds.splice(index, 1)
                    }
                })
            }
        },
        toggleCheck(checked, item) {
            if(checked) {
                item.checked = checked
                this.selecteds.push(item.codComarca)
            } else {
                item.checked = checked
                const index = this.selecteds.indexOf(item.codComarca)
                this.selecteds.splice(index, 1)
                this.configTable.checkedAll = false
            }

        },
        sortingChanged(ctx) {
            if(ctx.sortBy == 1) {
                this.configTable.sortField = 'nomeSimplificado'
            }
            if(ctx.sortBy == 2) {
                this.configTable.sortField = 'sigla'
            }
            if(ctx.sortBy == 3) {
                this.configTable.sortField = 'municipioSedeProtesto'
            }
            if(ctx.sortBy == 4) {
                this.configTable.sortField = 'limiteTitulosDiarios'
            }
            this.configTable.sortOrder = ctx.sortDesc ? 'desc' : 'asc'
            this.$emit('sortingChanged')
        }
    }

}
</script>

<style scoped>

.no-line {
    white-space: nowrap;
}

</style>
